<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-outTabs">
        <div class='h100vh-100'>
          <ToolBar :addBtn="true" :delBtn="true" :editBtn="true" :refreshBtn="true" :keywordsInput="true" @notice="notice" @keyword="keyword"></ToolBar>
          <div class="h100-40 h-scroll">
            <ejs-grid ref="grid" :allowPaging="true" :pageSettings="pageSettings" :height="screenHeight">
              <e-columns>
                <e-column type="checkbox" width="50" textAlign="center"></e-column>
                <e-column field="roleId" :visible="false"></e-column>
                <e-column field="roleName" :headerText="$t('Security.Role.name')" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="createTime" :headerText="$t('Security.Role.createTime')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="creator" :headerText="$t('Security.Role.creator')" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field="description" :headerText="$t('Security.User.desc')" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
              </e-columns>
            </ejs-grid>
            <ejs-pager ref="pager" :pageSize="pageSettings.pageSize" :pageCount="pageCount" @click="getRoleList"></ejs-pager>
          </div>
          <CustomDialog ref="addDialog" v-bind:element="addDialog.element" v-bind:styles="addDialog.styles">
            <template v-slot:dialog-content>
              <AddRole ref="addRole" v-bind:index="addRoleIndex" @childProps="getChildProps"></AddRole>
            </template>
          </CustomDialog>
          <CustomDialog ref="editDialog" v-bind:element="editDialog.element" v-bind:styles="editDialog.styles">
            <template v-slot:dialog-content>
              <EditRole ref="editRole" @childProps='getChildProps'></EditRole>
            </template>
          </CustomDialog>
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import CustomDialog from "../../components/common/CustomDialog";
import ToolBar from "../../components/security/roleManager/ToolBar";
import AddRole from "../../components/security/roleManager/AddRole";
import EditRole from "../../components/security/roleManager/EditRole";

export default {
  name: "RoleManager",
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.authorityManage')}` + '/' + `${this.$t('Security.roleManage')}` },
      keyString: "",
      pageSettings: { pageSize: 15 },
      pageCount: 4,
      pageNo: 1,
      dateFormat: {
        type: 'date', format: 'yyyy/MM/dd HH:mm:ss'
      },
      addStatus: true,
      addDialog: {
        element: {
          // target: "#app",
          isClose: true,
          refName: "tip",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t("Common.cancel")}` }
            },
            {
              click: this.lastAdd,
              buttonModel: {
                content: `${this.$t("Common.previous")}`,
                cssClass: "h-security-display-none"
              }
            },
            {
              click: this.nextAdd,
              buttonModel: { content: `${this.$t("Common.next")}` }
            }
          ],
          title: `${this.$t("Security.addRole")}`
        },
        styles: {
          width: "810px",
          height: "750px",
          model: true,
          visible: false
        }
      },
      editDialog: {
        element: {
          target: "#app",
          isClose: true,
          refName: "tip",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: {
                content: `${this.$t("Common.cancel")}`
              }
            },
            {
              click: this.editConfirm,
              buttonModel: { content: `${this.$t("Common.ok")}`, cssClass: 'primary-btn'}
            }
          ],
          title: `${this.$t("Security.editRole")}`
        },
        styles: {
          width: "810px",
          height: "750px",
          model: true,
          visible: false
        }
      },
      addRoleIndex: 0,
      addRoleProps: {}, // roleProps1, roleProps2, roleProps3
      screenHeight: document.body.clientHeight - 240
    };
  },
  components: {
    BasicLayout,
    CustomDialog,
    ToolBar,
    AddRole,
    EditRole
  },
  methods: {
    notice(btn) {
      if (btn === "add") {
        this.addFunc();
      }
      if (btn === "del") {
        this.delFuncShow();
      }
      if (btn === "edit") {
        this.editFunc();
      }
      if (btn === "refresh") {
        this.refreshFunc();
      }
      if (btn === "query") {
        this.queryFunc();
      }
    },
    keyword(data) {
      this.keyString = data;
    },
    getRoleList() {
      const url = "/lte/ems/role/query";
      this.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        roleName: this.keyString,
        pageNo: this.pageNo,
        pageSize: this.pageSettings.pageSize
      };
      this.axios.get(url, { params }).then(response => {
        const result = response.data.result;
        let showRe = [];
        result.forEach(item => {
          let re = {};
          re.creator = item.creator;
          re.sysEnable = item.sysEnable;
          re.createTime = new Date(item.createTime);
          re.roleId = item.roleId;
          re.roleName = item.roleName;
          re.description = item.description;
          showRe.push(re);
        });
        this.$refs.grid.ej2Instances.dataSource = showRe;
        this.$refs.pager.ej2Instances.totalRecordsCount = response.data.totalCount;
      });
    },
    getRecord() {
      const result = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (result == null || result == "") {
        this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
    addFunc() {
      this.addRoleIndex = 0;
      this.$refs.addRole.init();
      this.$refs.addDialog.show();
    },
    editFunc() {
      const record = this.getRecord();
      if (record == null) {
        return null;
      }
      if (record.length != 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      if (record[0].sysEnable==0) {
        this.$parent.showToast('warning',`${this.$t('Security.EadminCannotModify')}`);
        return null;
      }
      const url = "/lte/ems/role/findOne";
      const params = {
        roleId: record[0].roleId
      };
      this.axios.get(url, { params }).then(response => {
        this.$refs.editRole.init(response.data);
        this.$refs.editDialog.show();
      });
    },
    delFuncShow(){
      const record = this.getRecord();
      if (record == null) {
        return null;
      }
      for (let i=0; i<record.length; i++) {
        if (record[i].sysEnable==0) {
          this.$parent.showToast('warning',`${this.$t('Security.EadminCannotDelete')}`);
          return null;
        }
      }
      this.$layer.confirm({
        msg: `${this.$t('Common.tips.confirmTip')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: this.$t('System.confirm'),
          func: this.delFunc

        }
      });
    },
    delFunc() {
      const url = "/lte/ems/role/delete";
      const params = [];
      let record = this.getRecord();
      record.forEach(item => {
        params.push(item.roleId);
      });
      let That = this;
      this.axios.post(url, params).then(response => {
        if (response.data) {
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          That.getRoleList();
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
      });
    },
    refreshFunc() {
      this.getRoleList();
    },
    queryFunc() {
      this.$refs.pager.ej2Instances.currentPage = 1;
      this.getRoleList();
    },
    dialogHide() {
      this.$refs.addDialog.clear();
      this.$refs.editDialog.clear();
      this.$refs.addDialog.close();
      this.$refs.editDialog.close();
      this.addRoleIndex = 0;
    },
    lastAdd() {
      if (this.addRoleIndex == 0) {
        return null;
      }
      this.addRoleIndex -= 1;
    },
    async nextAdd() {
      const roleName = this.addRoleProps['roleProps1'].roleName;
      if (roleName.trim() === '') {
        this.$parent.showToast('warning',`${this.$t('Security.roleNameNotNull')}`);
        return null;
      }
      if (this.addRoleIndex === 0) {
        const exist = await this.findRole();
        if (exist) {
          this.$parent.showToast('warning',`${this.$t('Security.roleNameExists')}`);
          return null;
        }
      }
      if (this.addRoleIndex == 2) {
        // 确定按钮，整合添加角色用户、分域、权限、组织架构
        this.addRole();
        this.addRoleIndex = 0;
        this.$refs.addDialog.clear();
        this.$refs.addDialog.close();
        return null;
      }
      this.addRoleIndex += 1;
    },
    async findRole() {
      const url = "/lte/ems/role/isExists";
      const params = { roleName: this.addRoleProps['roleProps1'].roleName };
      let result = null;
      await this.axios.get(url, { params }).then(response => {
        result = response.data;
      });
      return result;
    },
    copyDeep(templateData) {
      // templateData 是要复制的数组或对象，这样的数组或者对象就是指向新的地址的
      let returnData = JSON.parse(JSON.stringify(templateData));
      returnData.buttonGroup.forEach((item, index) => {
        item.click = templateData.buttonGroup[index].click;
      });
      return returnData;
    },
    getChildProps(data) {
      this.addRoleProps = data;
    },
    addRole() {
      if (this.addStatus) {
        this.addStatus = false;
        const url = '/lte/ems/role/add';
        const params = {
          roleName: this.addRoleProps['roleProps1'].roleName,
          description: this.addRoleProps['roleProps1'].description,
          accountIdList: this.addRoleProps['roleProps1'].selected, // List<String>
          nodeIdList: this.addRoleProps['roleProps2'].nodeDomain, // List<Integer>
          resourceIdList: this.addRoleProps['roleProps2'].permission,
          vpnIdList: this.addRoleProps['roleProps3'].vpnIdList,  // Map<Integer, List<String>>
          createTime: new Date().getTime(),
        }
        let That = this;
        this.axios.post(url, params).then(response => {
          const result = response.data;
          if (result) {
            That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          } else {
            That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
          }
          That.addStatus = true;
          this.getRoleList();
        });
      }
    },
    editConfirm() {
      const url = "/lte/ems/role/edit";
      const record = this.getRecord();
      const params = {
        roleName: this.addRoleProps['roleProps1'].roleName,
        description: this.addRoleProps['roleProps1'].description,
        accountIdList: this.addRoleProps['roleProps1'].selected,
        resourceIdList: this.addRoleProps['roleProps2'].permission,
        nodeIdList: this.addRoleProps['roleProps2'].nodeDomain,
        vpnIdList: this.addRoleProps['roleProps3'].vpnIdList,
        roleId: record[0].roleId,
        createTime: new Date().getTime()
      };
      this.$refs.editDialog.clear();
      this.$refs.editDialog.close();
      let That = this;
      this.axios.post(url, params).then(response => {
        const result = response.data;
        if (result) {
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
        this.getRoleList();
      });
    }
  },
  mounted() {
    this.getRoleList();
    let That = this;
    window.onresize = () => {
      return (() => {
        That.screenHeight = document.body.clientHeight - 240;
      })()
    }
  },
  watch: {
    addRoleIndex() {
      const tempButton = this.copyDeep(this.addDialog.element);
      if (this.addRoleIndex === 2) {
        tempButton.buttonGroup[2].buttonModel.content = `${this.$t('Common.ok')}`;
        tempButton.buttonGroup[2].buttonModel.cssClass = 'primary-btn';
      } else {
        tempButton.buttonGroup[2].buttonModel.content = `${this.$t('Common.next')}`;
        tempButton.buttonGroup[2].buttonModel.cssClass = '';
      }
      if (this.addRoleIndex === 0) {
        tempButton.buttonGroup[1].buttonModel.cssClass = "h-security-display-none";
      } else {
        tempButton.buttonGroup[1].buttonModel.cssClass = "h-security-display-block";
      }
      this.addDialog.element = tempButton;
    },
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
};
</script>
